import React, { createContext, useContext, useReducer } from 'react';
import { demoHandlers, demoInitialState, demoReducer } from '../reducers/DemoReducer';
import { ParentContext } from './ParentContext';

export const DemoContext = createContext();

const DemoProvider = (props) => {

  const parentContext = useContext(ParentContext)
  const { fns } = parentContext ?? {}
  const { database_fns } = fns ?? {}

  const demo_initState = { demoOn: false, database_fns }
  const [demo_state, demo_dispatch] = useReducer(demoReducer, demoInitialState(demo_initState));
  const demo_handlers = demoHandlers(demo_dispatch, demo_state)

  const providerContext = () => <DemoContext.Provider
    value={{ demo_handlers, demo_state }}>
    {props.children}
  </DemoContext.Provider>

  return providerContext()
}

export default DemoProvider